import axios from "axios";
import { tmsApi } from "../api";

export const createServiceCity = async (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .post(tmsApi + "v1/entities/servicecity/create", body, config)
      .then((response) => {
        console.log("");
        console.log("Create service city API Response: ", response);
        console.log("");

        return response;
      });
  } catch (error) {
    console.log("");
    console.log("API Error: ", error);
    console.log("");

    return error;
  }
};

export const updateServiceCity = async (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .put(tmsApi + "v1/entities/servicecity/update", body, config)
      .then((response) => {
        console.log("");
        console.log("Update service city API Response: ", response);
        console.log("");

        return response;
      });
  } catch (error) {
    console.log("");
    console.log("API Error: ", error);
    console.log("");

    return error;
  }
};

export const deleteServiceCity = async (id, isDeleted) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };

  try {
    return axios
      .delete(
        tmsApi + `v1/entities/servicecity/${id}?isDeleted=${isDeleted}`,
        config
      )
      .then((response) => {
        console.log("");
        console.log("Delete service city API Response: ", response);
        console.log("");

        return response;
      });
  } catch (error) {
    console.log("");
    console.log("API Error: ", error);
    console.log("");

    return error;
  }
};

export const getServiceCityTableData = async (obj, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi + `v1/entities/servicecityall?page=${obj.page}&size=${obj.size}`,
        body,
        config
      )
      .then((resp) => {
        console.log(resp, "response");
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};
export const getServiceCityDetails = async (obj) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  try {
    return axios
      .get(
        tmsApi + `config/serviceCity/${obj?.service_city_id}`,
        config
      )
      .then((resp) => {
        return resp;
      });
  } catch (error) {
    console.log("error", error);
  }
};

export const getAirportsByCity = async (cityId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.get(tmsApi + `config/serviceCity/${cityId}/airport`, config);
};

export const createAirportTerminal = async (cityId, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(
    tmsApi + `config/serviceCity/${cityId}/airport`,
    body,
    config
  );
};

export const updateAirportTerminal = async (cityId, terminalId, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(
    tmsApi + `config/serviceCity/${cityId}/airport/${terminalId}`,
    body,
    config
  );
};

export const getTollsByCity = async (cityId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.get(tmsApi + `config/serviceCity/${cityId}/toll`, config);
};

export const createToll = async (cityId, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(tmsApi + `config/serviceCity/${cityId}/toll`, body, config);
};

export const updateToll = async (cityId, suburbId, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(tmsApi + `config/serviceCity/${cityId}/toll/${suburbId}`, body, config);
};

export const deleteToll = async (cityId, suburbId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.delete(tmsApi + `config/serviceCity/${cityId}/toll/${suburbId}`, config);
};

export const getSuburbsByCity = async (cityId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.get(tmsApi + `config/serviceCity/${cityId}/suburb`, config);
};

export const checkRouteExists = async (cityId, fromSuburbId, toSuburbId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.get(
    tmsApi + `config/serviceCity/${cityId}/suburbToSuburb/check?fromSuburbId=${fromSuburbId}&toSuburbId=${toSuburbId}`,
    config
  );
};

export const createRoute = async (cityId, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(tmsApi + `config/serviceCity/${cityId}/suburbToSuburb`, body, config);
};

export const getRoutesByCity = async (cityId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.get(tmsApi + `config/serviceCity/${cityId}/suburbToSuburb`, config);
};

export const updateRoute = async (cityId, otherChargesId, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.put(
    tmsApi + `config/serviceCity/${cityId}/suburbToSuburb/${otherChargesId}`,
    body,
    config
  );
};

export const deleteRoute = async (cityId, otherChargesId) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.delete(
    tmsApi + `config/serviceCity/${cityId}/suburbToSuburb/${otherChargesId}`,
    config
  );
};

export const createConfigServiceCity = async (body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(tmsApi + `config/serviceCity`, body, config);
};

export const updateConfigServiceCity = async (id, body) => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.post(tmsApi + `config/serviceCity/${id}`, body, config);
};

export const getConfigServiceCities = async () => {
  const config = {
    headers: {
      token: localStorage.getItem("token"),
      "Access-Control-Allow-Origin": "*",
    },
  };
  return axios.get(tmsApi + `config/serviceCity`, config);
};
